import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga4';
import { Box, Typography, RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material';
import BaseModal from 'components/BaseModal';
import { CartAbandonmentReasonEnum } from 'enums';
import { useAuthUser } from 'features/auth/AuthUserContext';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onActionClick: PropTypes.func.isRequired,
};

export default function CartAbandonmentModal({ open, onClose, onActionClick }) {
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const { user } = useAuthUser();

  function sendTrackingEvents() {
    ReactGA.event({
      category: 'checkout',
      action: 'cart_abandonment',
      label: 'When user click in "Share with us" button',
      value: user.id,
    });
  }

  function handleActionClick() {
    sendTrackingEvents();

    onActionClick({ reason, description });

    setReason('');
    setDescription('');
  }

  return (
    <BaseModal
      size="sm"
      open={open}
      title={<b>We'll truly miss you!</b>}
      content={
        <Box px={2}>
          <Typography>But first, can you let us know why you're leaving?</Typography>

          <Box display="flex" justifyContent="center" my={4}>
            <RadioGroup value={reason} onChange={({ target: { value } }) => setReason(value)}>
              <FormControlLabel
                label="I had payment issues"
                value={CartAbandonmentReasonEnum.PAYMENT_ISSUE}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="I´m not ready to subscribe"
                value={CartAbandonmentReasonEnum.NOT_READY}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="I chose the wrong plan"
                value={CartAbandonmentReasonEnum.WRONG_PLAN}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="It's too expensive for me"
                value={CartAbandonmentReasonEnum.TOO_EXPENSIVE}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="Other reasons"
                value={CartAbandonmentReasonEnum.OTHER}
                control={<Radio color="secondary" />}
              />
            </RadioGroup>
          </Box>

          {reason === CartAbandonmentReasonEnum.OTHER && (
            <TextField
              fullWidth={true}
              multiline={true}
              variant="outlined"
              inputProps={{ minRows: 2 }}
              label="Tell us a little more about the problem"
              value={description}
              onChange={({ target: { value } }) => setDescription(value)}
            />
          )}
        </Box>
      }
      actionText="Share with us"
      disableActionButton={!reason}
      cancelButton={false}
      onActionClick={handleActionClick}
      onClose={onClose}
    />
  );
}

CartAbandonmentModal.propTypes = Props;
